/**
 * 검색 input에서 Enter 시 인접 검색 버튼을 클릭합니다.
 * (전역 위임 — 개별 화면에 onKeyUp을 일일이 달지 않아도 동작)
 */
const SEARCH_BUTTON_SELECTOR = [
  ".maintenance-search-btn",
  ".btn_search",
  ".search-filter-bar__btn",
  ".admin-notify-search__btn",
  "button[aria-label='검색']",
  ".icon_search_black",
  ".icon_search_gray",
  ".icon_search_blue",
  ".icon_search_white",
  ".icon_search",
  ".search_form_btn",
  "i[class*='icon_search']",
  "button[class*='search']",
].join(", ");

const SEARCH_ROOT_SELECTOR = [
  ".maintenance-search-input",
  ".search-filter-bar",
  ".admin_manage_search_row",
  ".search_input_wrap",
  ".admin-notify-search",
  ".admin-notify-search__inner",
  ".expired-annual-search",
  ".inventor_search_wrap",
  ".yearpay_search",
  ".yearpay_search__input",
  ".search_form",
  ".search-container",
  "[data-enter-search]",
].join(", ");

const SKIP_INPUT_TYPES = new Set([
  "password",
  "checkbox",
  "radio",
  "file",
  "hidden",
  "submit",
  "button",
  "reset",
  "image",
  "range",
  "color",
  "date",
  "datetime-local",
  "month",
  "time",
  "week",
]);

function findSearchButton(input) {
  const root = input.closest(SEARCH_ROOT_SELECTOR);
  if (root) {
    const inRoot = root.querySelector(SEARCH_BUTTON_SELECTOR);
    if (inRoot) return inRoot;
  }

  const parent = input.parentElement;
  if (parent) {
    const inParent = parent.querySelector(SEARCH_BUTTON_SELECTOR);
    if (inParent && inParent !== input) return inParent;
  }

  let sibling = input.nextElementSibling;
  while (sibling) {
    if (
      sibling.matches?.(SEARCH_BUTTON_SELECTOR) ||
      (typeof sibling.className === "string" &&
        /search/i.test(sibling.className))
    ) {
      return sibling;
    }
    sibling = sibling.nextElementSibling;
  }

  return null;
}

export function bindEnterToSearch() {
  const onKeyDown = (e) => {
    if (e.key !== "Enter") return;
    if (e.isComposing || e.keyCode === 229) return;

    const target = e.target;
    if (!(target instanceof HTMLInputElement)) return;
    if (target.disabled || target.readOnly) return;

    const type = (target.type || "text").toLowerCase();
    if (SKIP_INPUT_TYPES.has(type)) return;

    // 이미 submit 버튼이 있는 form이면 브라우저 기본 동작에 맡김
    const form = target.form;
    if (form?.querySelector("button[type='submit'], input[type='submit']")) {
      return;
    }

    const button = findSearchButton(target);
    if (!button || button.disabled) return;

    e.preventDefault();
    button.click();
  };

  document.addEventListener("keydown", onKeyDown);
  return () => document.removeEventListener("keydown", onKeyDown);
}
